import React from 'react';

import { FacetCounts } from 'lib/AutolistAPI';
import SearchFilter from '../SearchFilter';

import { styles } from './styles';

export default function Sidebar({ facetCounts }: { facetCounts?: FacetCounts }): JSX.Element {
  return (
    <>
      <div className="srp-search-filters-sidebar">
        <SearchFilter facetCounts={facetCounts} />
      </div>
      <style jsx>{styles}</style>
    </>
  );
}
